<div *ngIf="isLoading" class="loading-indicator-container">
    <app-loading-spinner></app-loading-spinner>
</div>
<form [formGroup]="reportDownloadForm" *ngIf="!isLoading">
    <app-input-datepicker [formControl]="control('startDate')"
                          [showErrors]="control('startDate').invalid && control('startDate').value"
                          [outputDateFormat]="outputDateFormat"
                          [appendTo]="appendTo"
                          [placeholder]="'reportDownloadForm.startDatePicker.label' | translate"
                          (dateChange)="onDateChange('startDate', $event)">
    </app-input-datepicker>
    <app-input-datepicker [formControl]="control('endDate')"
                          [showErrors]="control('endDate').invalid && control('endDate').value"
                          [outputDateFormat]="outputDateFormat"
                          [appendTo]="appendTo"
                          [placeholder]="'reportDownloadForm.endDatePicker.label' | translate"
                          (dateChange)="onDateChange('endDate', $event)">
    </app-input-datepicker>
    <app-button type="primary"
                (click)="onReportDownload()">{{ downloadButtonText || ('reportDownloadForm.downloadButton' | translate) }}
    </app-button>
</form>
